import { Response } from 'miragejs';
import { StatusCodes as HTTP } from 'http-status-codes';
import { getSavedState } from '@/helpers/storageOperations';

const translate = () => {
    return `The pain is important, the main storage problems, but I give this kind of time to as low as any great pain and pain. For the purpose of coming to a minimum, who of ours should exercise any employment except to take advantage of the consequences from it. But the pain in the film is irure to condemn, in the pleasure it wants to escape from the pain of being clum in pain, none result. They are the exceptions the blinds yearn for, they do not see, they are the ones who abandon their responsibilities to the fault that is soothing the soul's hardships.`;
};

export default server => {
    // @NOTE that part of code was taken out from /feed-items after `category_id` (tw, fb..) was replaced with `social_type` (1, 2) which custom inbox does not own
    server.get('/v1/feed-items/custom-inboxes', ({ feedItems }, { queryParams: { user_id } }) => {
        const { models: foundFeedItems } = feedItems.where(feedItem => feedItem.related_profiles.includes(user_id));

        if (!foundFeedItems.length) {
            return [];
        }

        const items = [];

        for (let i = 0; i < 2; i++) {
            const index = Math.floor(Math.random() * foundFeedItems.length);

            items.push(foundFeedItems[index]);
        }

        return items;
    });

    server.get('/v1/feed-items', ({ feedItems }, { queryParams: { user_id, social_type } }) => {
        const { models: foundFeedItems } = feedItems.where(feedItem => feedItem.related_profiles.includes(user_id));

        let result = foundFeedItems;

        if (social_type) {
            result = foundFeedItems.filter(feedItem => feedItem.social_type === Number(social_type));
        }

        return result;
    });

    server.get(
        '/v1/feed-items/search-results',
        ({ feedItems }, { queryParams: { user_id, sentiment, social_types } }) => {
            if (!social_types?.length) {
                return [];
            }

            const { models: filteredFeedItems } = feedItems.where(
                feedItem =>
                    feedItem.related_profiles.includes(user_id) &&
                    social_types.includes(feedItem.social_type.toString())
            );

            let result = filteredFeedItems;

            if (!isNaN(sentiment)) {
                result = filteredFeedItems.filter(feedItem => feedItem.sentiment === parseInt(sentiment));
            }

            return result;
        }
    );

    server.get('/v1/feed-items/drafts', ({ feedItems }, { queryParams: { user_id } }) => {
        const { models: filteredFeedItems } = feedItems.where(feedItem => feedItem.related_profiles.includes(user_id));

        if (!filteredFeedItems?.length) {
            return [];
        }

        const randomFeedItem = filteredFeedItems[Math.floor(Math.random() * filteredFeedItems.length)];

        return [randomFeedItem];
    });

    server.get('/v1/feed-items/count', (schema, { queryParams: { user_id } }) => {
        let result = {
            success: false
        };

        if (user_id) {
            const unique = Math.floor(Math.random() * 1000);
            const total = Math.floor(Math.random() * 10000);

            result = {
                success: true,
                data: {
                    unique,
                    total
                }
            };
        }

        return result;
    });

    server.get('/v1/feed-items/sentiments', ({ feedItems }, { queryParams: { user_id } }) => {
        const { models: userFeedItems } = feedItems.where(feedItem => feedItem.related_profiles.includes(user_id));

        const counts = userFeedItems.reduce((accumulator, current) => {
            const { social_type, sentiment } = current;

            let index = accumulator.findIndex(element => element.social_type === social_type);

            if (index === -1) {
                accumulator.push({
                    social_type,
                    amount: 0,
                    sentiments: {
                        positive: 0,
                        negative: 0,
                        neutral: 0
                    }
                });

                index = accumulator.length - 1;
            }

            switch (sentiment) {
                case 1:
                    accumulator[index]['sentiments'].positive++;
                    break;

                case -1:
                    accumulator[index]['sentiments'].negative++;
                    break;

                case 0:
                    accumulator[index]['sentiments'].neutral++;
                    break;
            }

            accumulator[index]['amount']++;

            return accumulator;
        }, []);

        return counts;
    });

    server.get('/v1/feed-items/assigned-to-me-count', ({ feedItems }) => {
        const { id } = getSavedState('auth.currentUser');

        const { models: items } = feedItems.where(
            feedItem => feedItem.assignedTo?.id === id && feedItem.assignedTo?.type === 'users'
        );

        return items.length;
    });

    server.get('/v1/feed-items/assigned-to-me', ({ feedItems }) => {
        const { id } = getSavedState('auth.currentUser');

        const { models: items } = feedItems.where(
            feedItem => feedItem.assignedTo?.id === id && feedItem.assignedTo?.type === 'users'
        );

        return items;
    });

    server.post('/v1/feed-items/status/properties/translate', (schema, { requestBody }) => {
        const { lang, text, status_id } = JSON.parse(requestBody);

        return translate(text, lang, status_id);
    });

    server.post('/v1/feed-items/status/properties/state', (schema, { requestBody }) => {
        const { status_id, state } = JSON.parse(requestBody);

        const feedItem = schema.feedItems.findBy(({ status }) => status.status_id === status_id);

        if (!feedItem) {
            return new Response(HTTP.NOT_FOUND);
        }

        feedItem.update({ state });

        return { feedItem: feedItem.attrs };
    });

    server.post('/v1/feed-items/:id/assign', (schema, { requestBody, params: { id } }) => {
        const { message, assigned_to } = JSON.parse(requestBody);

        const feedItem = schema.feedItems.find(id);

        if (!feedItem) {
            return new Response(HTTP.NOT_FOUND);
        }

        const { id: sourceId, type: sourceType } = assigned_to;
        const {
            attrs: { firstName, lastName, name }
        } = schema[sourceType].find(sourceId);

        const { firstName: userFirstName, lastName: userLastName } = getSavedState('auth.currentUser');

        feedItem.update({
            assignedTo: {
                ...assigned_to,
                message,
                sourceName: name || `${firstName} ${lastName}`,
                at: new Date(),
                by: `${userFirstName} ${userLastName}`
            }
        });

        return feedItem.attrs;
    });

    server.post('/v1/feed-items/:id/unassign', (schema, { params: { id } }) => {
        const feedItem = schema.feedItems.find(id);

        if (!feedItem) {
            return new Response(HTTP.NOT_FOUND);
        }

        feedItem.update({
            assignedTo: null
        });

        return feedItem.attrs;
    });

    server.post('/v1/feed-items/:id/set-labels', (schema, { requestBody, params: { id } }) => {
        const { label_ids } = JSON.parse(requestBody);

        const feedItem = schema.feedItems.find(id);

        if (!feedItem) {
            return new Response(HTTP.NOT_FOUND);
        }

        feedItem.update({
            labelIds: label_ids
        });

        return feedItem.attrs;
    });
};
